import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { reactive } from "vue";
const app = createApp(App).use(router)
app.config.globalProperties.$carrito = reactive({
    productos: []
})
app.mount('#app')
